<atn-ds-slideout-overlay name="Filters">
  <i
    actions
    class="atn-icon atn-close atn-red"
    (click)="cancelClickHandler()"
  ></i>

  <div class="atn-space-unassigned-sponsored-accounts-filters">
    <div class="atn-space-unassigned-sponsored-accounts-filters__content">
      <atn-space-dimension-filter
        [plugin]="organizationDimensionFilterPlugin"
      />
    </div>

    <div class="atn-space-unassigned-sponsored-accounts-filters__footer">
      <atn-ds-button
        type="transparent"
        (click)="resetClickHandler()"
      >
        Reset
      </atn-ds-button>

      <div
        class="atn-space-unassigned-sponsored-accounts-filters__footer-buttons"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="applyClickHandler()">Apply</atn-ds-button>
      </div>
    </div>
  </div>
</atn-ds-slideout-overlay>
